<template>
  <!-- TeamsManage -->
  <el-tab-pane label="TeamsManage">
    <div>
      <div class="row">
        <div class="col-sm-12">
          <el-card>
            <h4 style="color: #3b291d">TeamsManage</h4>
            <!-- Start search part -->

            <div class="row">
              <div class="col-sm-2">
                <base-input label="name">
                  <el-input placeholder="name" clearable style="
                      border: 1px solid hsl(0, 0%, 5%);
                      border-radius: 5px;
                      --el-input-focus-border-color: #f0f3f7;
                    " v-model="searchKeyTeam.name"></el-input>
                </base-input>
              </div>
              <div class="col-sm-3">
                <base-input label="DepartmentName" :clearable="true">
                  <el-select v-model="searchKeyTeam.departmentName" class="select-primary" filterable size="large"
                    placeholder="DepartmentName">
                    <el-option label="All" value=""> </el-option>
                    <el-option label="Billboard" value="Billboard"> </el-option>
                    <el-option label="Bus" value="Bus"> </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-sm-2">
                <base-input label="Status" :clearable="true">
                  <el-select v-model="searchKeyTeam.status" class="select-primary" filterable size="large"
                    placeholder="Status">
                    <el-option label="all" :value="null"> </el-option>
                    <el-option label="active" value="active"> </el-option>
                    <el-option label="inactive" value="inactive"> </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-sm-3">
                <div style="column-gap: 5px; top: 30px"></div>
                <div class="row">
                  <div style="
                      column-gap: 5px;
                      text-align: right;
                      position: absolute;
                      bottom: 5px;
                    ">
                    <base-button type="primary" @click="searchTeam" style="width: 100px">Search</base-button>
                    <base-button type="primary" @click="resetTeam" style="width: 100px">Reset</base-button>
                  </div>
                </div>
              </div>
            </div>
            <!-- end Search part-->
            <div class="row" style="margin-top: 20px">
              <div class="col-sm-12" style="display: flex">
                <div class="col-sm-3">
                  <el-link type="primary" @click="OpenAddTeam">Add Team</el-link>
                </div>
                <span style="
                    margin-left: auto;
                    line-height: 32px;
                    padding-right: 20px;
                  ">
                  <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                    :page-sizes="[10, 20, 30, 50, 100]" :small="small" :background="true"
                    layout="total, sizes, prev, pager, next, jumper" :total="searchKeyTeam.total"
                    @size-change="ChangePageSearchTeam" @current-change="ChangePageSearchTeam" />
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <el-table :data="teamlist" style="width: 100%" border header-row-class-name="header-row"
                  @filter-change="searchTeam" table-layout="auto" cell-class-name="report-cell">
                  <tablecolumn prop="departmentName" label="DepartmentName" :width="160" />
                  <tablecolumn prop="name" label="name" :width="200" />
                  <tablecolumn prop="alias" label="alias" :width="140" />
                  <el-table-column prop="status" label="status" :width="140" />
                  <tablecolumn prop="teamHead" label="TeamHead" :width="160" />
                  <tablecolumn prop="groupName" label="GroupName" :width="140" />
                  <tablecolumn prop="groupHead" label="GroupHead" :width="160" />
                  <tablecolumn prop="departmentName" label="DepartmentName" :width="160" />
                  <tablecolumn prop="id" label="id" v-if="false" :width="250" />
                  <tablecolumn prop="teamHeadID" label="TeamHeadID" :width="250" v-if="false" />
                  <tablecolumn prop="groupID" v-if="false" label="GroupID" :width="250" />
                  <tablecolumn prop="groupHeadID" label="GroupHeadID" :width="250" v-if="false" />
                  <tablecolumn prop="departmentID" label="DepartmentID" :width="250" v-if="false" />
                  <tablecolumn prop="departmentHeadID" label="DepartmentHeadID" :width="250" v-if="false" />

                  <el-table-column prop="created_at" label="created_at" :width="200" />
                  <el-table-column prop="created_by" label="created_by" :width="120" />
                  <el-table-column prop="updated_at" label="updated_at" :width="200" />
                  <el-table-column prop="updated_by" label="updated_by" :width="120" />

                  <el-table-column prop="" fixed="right" label="Action"  class-name="action">
                    <template #default="scope">
                      <el-link type="primary" @click="OpenUpdateTeam(scope.row)">Update</el-link>
                      <br />
                      <el-link type="danger" @click="OpenDeleteTeam(scope.row)">Delete</el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div></div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 添加Team -->
    <div>
      <el-dialog v-model="dialogFormOpenAddTeam" title="Add Teams" :width="800">
        <el-form :model="teamInfoData">
          <el-form-item label="name" required :label-width="formLabelWidth">
            <el-input v-model="teamInfoData.value.name" autocomplete="off" />
          </el-form-item>
          <el-form-item label="alias" :label-width="formLabelWidth">
            <el-input v-model="teamInfoData.value.alias" autocomplete="off" />
          </el-form-item>

          <el-form-item label="status" :label-width="formLabelWidth" required>
            <el-select v-model="teamInfoData.value.status">
              <el-option label="active" value="active" />
              <el-option label="inactive" value="inactive" />
            </el-select>
          </el-form-item>
          <el-form-item label="DepartmentName" :label-width="formLabelWidth" required>
            <el-select v-model="teamInfoData.value.departmentName">
              <el-option label="Billboard" value="Billboard" />
              <el-option label="Bus" value="Bus" />
            </el-select>
          </el-form-item>

          <el-form-item label="Group" :label-width="formLabelWidth">
            <el-select v-model="teamInfoData.value.groupID" class="select-primary" size="large" filterable placeholder="">
              <el-option v-for="item in grouplist" :label="item.name" :value="item.id" :key="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Team Head" :label-width="formLabelWidth">
            <el-select v-model="teamInfoData.value.teamHeadID" class="select-primary" size="large" filterable
              placeholder="">
              <el-option v-for="item in userlist" :label="item.name" :value="item.id" :key="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogFormOpenAddTeam = false">Cancel</el-button>
            <el-button type="primary" @click="AddTeams"> Confirm </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <!-- 修改Team -->
    <div>
      <el-dialog v-model="dialogFormOpenUpdateTeam" title="Update Teams" :width="800">
        <el-form :model="teamInfoData">
          <el-form-item label="name" required :label-width="formLabelWidth">
            <el-input v-model="teamInfoData.value.name" autocomplete="off" />
          </el-form-item>
          <el-form-item label="alias" :label-width="formLabelWidth">
            <el-input v-model="teamInfoData.value.alias" autocomplete="off" />
          </el-form-item>

          <el-form-item label="status" :label-width="formLabelWidth" required>
            <el-select v-model="teamInfoData.value.status">
              <el-option label="active" value="active" />
              <el-option label="inactive" value="inactive" />
            </el-select>
          </el-form-item>
          <el-form-item label="DepartmentName" :label-width="formLabelWidth" required>
            <el-select v-model="teamInfoData.value.departmentName">
              <el-option label="Billboard" value="Billboard" />
              <el-option label="Bus" value="Bus" />
            </el-select>
          </el-form-item>

          <el-form-item label="Group" :label-width="formLabelWidth">
            <el-select v-model="teamInfoData.value.groupID" class="select-primary" size="large" filterable placeholder="">
              <el-option v-for="item in grouplist" :label="item.name" :value="item.id" :key="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Team Head" :label-width="formLabelWidth">
            <el-select v-model="teamInfoData.value.teamHeadID" class="select-primary" size="large" filterable
              placeholder="">
              <el-option v-for="item in userlist" :label="item.name" :value="item.id" :key="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogFormOpenUpdateTeam = false">Cancel</el-button>
            <el-button type="primary" @click="UpdateTeams"> Confirm </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </el-tab-pane>
</template>

<script setup>
// import './css/index.css';
import { watch, ref, reactive, onBeforeMount, onMounted } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import basePagination from '@/components/newUI/BasePagination';
import tablecolumn from '@/components/tablecolumn';
import PubSub from 'pubsub-js';

const formLabelWidth = '140px';
const currentPage = ref(1);
const pageSize = ref(10);

// router
import router from '@/router';
import profile from '@/network/profile';

// icon
import { Edit, Search } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';

// tool
import {
  formatterCellMoney,
  formatterCellDate,
  formatterCellDateTime,
} from '@/assets/js/formatter';
onBeforeMount(async () => {
  await searchTeam();
});

//#region Teams
const teamlist = ref([]);
const dialogFormOpenAddTeam = ref(false);
const dialogFormOpenUpdateTeam = ref(false);
const teamInfoData = reactive({});
const userlist = ref([]);
const grouplist = ref([]);

//变更分页
const ChangePageSearchTeam = async (data) => {
  searchKeyTeam.pageIndex = currentPage;
  searchKeyTeam.pageSize = pageSize;
  searchTeam();
};
const searchKeyTeam = reactive({
  pageIndex: 1,
  pageSize: 10,
  status: 'active',
});

const searchTeam = async () => {
  const search_res = await profile
    .GetTeamsList(searchKeyTeam)
    .then((res) => res);
  searchKeyTeam.total = search_res.data.total;
  teamlist.value = search_res.data.list;
  userlist.value = search_res.data.userlist;
  grouplist.value = search_res.data.grouplist;
};

const resetTeam = async () => {
  //清空对象
  Object.keys(searchKeyTeam).map((key) => {
    delete searchKeyTeam[key];
  });
  searchKeyTeam.pageIndex = 1;
  searchKeyTeam.pageSize = 10;
  searchKeyTeam.status = 'active';
  searchTeam();
};
//打开添加Team
const OpenAddTeam = async (data) => {
  dialogFormOpenAddTeam.value = true;
  teamInfoData.value = {};
};
//添加Team
const AddTeams = async (data) => {
  dialogFormOpenAddTeam.value = false;
  const result = await profile.AddTeams(teamInfoData.value).then((res) => res);
  if (result.data === '') {
    ElMessage({
      message: '添加成功',
      type: 'success',
    });
  } else {
    ElMessage({
      message: result.data,
      type: 'warning',
    });
  }
  await searchTeam();
};
//打开修改窗口
const OpenUpdateTeam = async (data) => {
  dialogFormOpenUpdateTeam.value = true;
  teamInfoData.value = data;
};
//修改Team
const UpdateTeams = async (data) => {
  dialogFormOpenUpdateTeam.value = false;
  const result = await profile
    .UpdateTeams(teamInfoData.value)
    .then((res) => res);
  if (result.data === '') {
    ElMessage({
      message: '修改成功',
      type: 'success',
    });
  } else {
    ElMessage({
      message: result.data,
      type: 'warning',
    });
  }
  await searchTeam();
};
//删除
const OpenDeleteTeam = async (data) => {
  teamInfoData.value = data;
  ElMessageBox.confirm(
    'Are you sure to delete (' + data.name + ')?',
    'Warning',
    {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
    }
  )
    .then(async () => {
      const result = await profile
        .DeleteTeams(teamInfoData.value)
        .then((res) => res);
      if (result.data === '') {
        ElMessage({
          message: '删除成功',
          type: 'success',
        });
      } else {
        ElMessage({
          message: result.data,
          type: 'warning',
        });
      }
      await searchTeam();
    })
    .catch(() => { });
};
//#endregion

//组件传值
onMounted(async () => {
  PubSub.subscribe('mode', (name, data) => {
    searchKeyTeam[`${data.key}`] = data.value;
    searchTeam();
  });
});
</script>

<style scoped>
.el-button--text {
  margin-right: 15px;
}

.el-select {
  width: 300px;
}

.el-input {
  width: 300px;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>
